import { useNavigate } from "react-router-dom";
import { ChevronRight, Building, Mail, MoreHorizontal } from "lucide-react";

interface Props {
  hospitals: any[];
}



interface Props {
  hospitals: any[];
}

const HospitalsTable = ({ hospitals }: Props) => {
  const navigate = useNavigate();
  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead className="bg-gray-50 border-b border-gray-100">
          <tr>
            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Hospital Name</th>
            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Contact</th>
            <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Status</th>
            <th className="px-6 py-4 text-right text-xs font-semibold text-gray-500 uppercase tracking-wider">Action</th>
          </tr>
        </thead>

        <tbody className="divide-y divide-gray-50">
          {hospitals.map((hospital) => (
            <tr
              key={hospital.id}
              onClick={() => navigate(`/hospitals/${hospital.id}`)}
              className="group hover:bg-gray-50 transition-colors duration-150 cursor-pointer"
            >
              <td className="px-6 py-4">
                <div className="flex items-center gap-3">
                  <div className="h-10 w-10 rounded-lg bg-primary-50 flex items-center justify-center text-primary-600 shrink-0">
                    <Building size={18} />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-gray-900 group-hover:text-primary-700 transition-colors">{hospital.hospitalName}</p>
                    <p className="text-xs text-gray-400">ID: {hospital.registrationNumber || "N/A"}</p>
                  </div>
                </div>
              </td>
              <td className="px-6 py-4">
                <div className="flex flex-col gap-1">
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <Mail size={14} className="text-gray-400" />
                    {hospital.officialEmail}
                  </div>
                </div>
              </td>
              <td className="px-6 py-4">
                <StatusBadge status={hospital.status} />
              </td>
              <td className="px-6 py-4 text-right">
                <div className="inline-flex h-8 w-8 items-center justify-center rounded-full text-gray-400 hover:bg-white hover:shadow-sm hover:text-primary-600 transition-all">
                  <ChevronRight size={18} />
                </div>
              </td>
            </tr>
          ))}
          {hospitals.length === 0 && (
            <tr>
              <td colSpan={4} className="px-6 py-12 text-center text-gray-500">
                No hospitals found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

const StatusBadge = ({ status }: { status: string }) => {
  let classes = "bg-gray-100 text-gray-600";

  switch (status?.toUpperCase()) {
    case "ACTIVE":
      classes = "bg-green-50 text-green-700 border border-green-100 ring-1 ring-green-600/10";
      break;
    case "PENDING":
      classes = "bg-yellow-50 text-yellow-700 border border-yellow-100 ring-1 ring-yellow-600/10";
      break;
    case "SUSPENDED":
      classes = "bg-red-50 text-red-700 border border-red-100 ring-1 ring-red-600/10";
      break;
    default:
      break;
  }

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${classes}`}>
      {status || "Unknown"}
    </span>
  );
}

export default HospitalsTable;


